<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card no-shadow >
         <div class="vx-row">

           <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
             <label class="text-sm opacity-100 text-bold">Batch Code</label>
             <vs-input type="search"  placeholder="Search.." v-model="filters['work-order-code']" class="mb-4 md:mb-0 w-full"/>
           </div>

           <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
             <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select  :clearable="true" name="type" label="key" placeholder="" :reduce="option => option.value" v-model="filters['status']" :options="statusList" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
           </div>
         </div>
        </vx-card>

        <vx-card no-shadow class="pt-1">
          <div slot="no-body" class="mt-4">
            <vs-table
              id="sundry-item-list-table"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="items"
              sort
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%"  class="text-xs" sort-key="sundry_item_code">BATCH CODE</vs-th>
                <vs-th width="10%"  class="text-xs">MANUFACTURE DATE</vs-th>
                <vs-th width="10%"  class="text-xs">EXP DATE</vs-th>
                <vs-th width="10%"  class="text-xs">MLOR %</vs-th>
                <vs-th width="10%" class="text-xs">BATCH QTY (KG)</vs-th>
                <vs-th width="10%" class="text-xs">COMPLETED/AVAILABLE QTY (KG)</vs-th>
                <vs-th width="10%" class="text-xs">PRODUCT ORDER CODE</vs-th>
                <vs-th width="20%" class="text-xs">STATUS</vs-th>
                <vs-th width="10%" class="text-xs">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td class="text-primary font-semibold cursor-pointer" :data="data[indextr].work_order">
                    <span @click.stop="onClickOpenWo(data[indextr].work_order_id)">{{ data[indextr].work_order}}</span>
                  </vs-td>

                  <vs-td :data="data[indextr].manufacture_date">
                    {{ data[indextr].manufacture_date}}
                  </vs-td>

                  <vs-td :data="data[indextr].expiration_date">
                    {{ data[indextr].expiration_date}}
                  </vs-td>

                  <vs-td :data="data[indextr].mlor">
                    {{ data[indextr].mlor}}
                  </vs-td>

                  <vs-td :data="data[indextr].total_quantity">
                    {{ toFixed(data[indextr].total_quantity)}}
                  </vs-td>


                  <vs-td :data="data[indextr].completed_quantity">
                    {{ toFixed(data[indextr].completed_quantity)}}
                  </vs-td>

                  <vs-td :data="data[indextr].product_order_code">
                    {{ data[indextr].product_order_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].status">
                    <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                      {{ data[indextr].status | stock_status_format}}
                    </vs-chip>
                  </vs-td>


                  <vs-td >
                    <div class="vx-row">
                      <vx-tooltip style="z-index: 9999" text="Assign formulation stock" position="top" v-if="data[indextr].status === 'In_Stock'">
                        <vs-button class="ml-3"
                                   @click.stop="onClickAssignFormulation(data[indextr].formulation_id, data[indextr].id, data[indextr].status, data[indextr].completed_quantity)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-share"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip style="z-index: 9999" text="Adjust formulation stock" position="top" v-if="['In_Stock', 'Expired', 'In-Dispatch'].includes(data[indextr].status)">
                        <vs-button class="ml-3"
                                   @click.stop="onClickStockAdjust(data[indextr])"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-trending-up"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip style="z-index: 9999" text="Un-allocate stock" position="top" v-if="['Pending Dispatch'].includes(data[indextr].status)">
                        <vs-button class="ml-3"
                                   @click.stop="onClickUnAllocateStock(data[indextr])"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-corner-up-left"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip style="z-index: 9999" text="Print FG Label" position="top">
                        <vs-button class="ml-3"
                                   @click.stop="onClickLabelPrint(data[indextr])"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-printer"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-if="items.length > 0 "
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <assign-formulation-stock-pop-up v-on:refreshData="refreshData" ref="assignFormulationStockPopUp"/>
    <adjust-product-stock-pop-up ref="adjustProductStockPopUp"/>
    <product-stock-label-pop-up ref="productStockLabelPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const ManufacturingRepository = RepositoryFactory.get('manufacturing')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";
  import AssignFormulationStockPopUp from "@/components/popups/manufacturing/formulation-stock/AssignFormulationStockPopUp";
  import AdjustProductStockPopUp
    from "@/components/popups/manufacturing/formulation-stock/AdjustProductStockPopUp";
  import ProductStockLabelPopUp from '@/components/popups/inventory/stock/ProductStockLabelPopUp.vue';

  export default {
    name: 'AllUsersList',
    props: {
      formulation_code: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        items: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
        activePrompt: false,
        current_stock_level: '',
        selected_product_id: '',
        statusList:[ 
          {key: 'In Stock', value: 'In_Stock'},
          {key: 'In Dispatch', value: 'In-Dispatch'},
          {key: 'Dispatched', value: 'Dispatched'},
          {key: 'Pending Dispatch', value: 'Pending_Dispatch'}, 
          // {key: 'In Progress', value: 'In_Progress'},
          {key: 'Pending Dispatch', value: 'Pending Dispatch'},
          {key: 'Re Blend', value: 'Re_Blend'}, 
          {key: 'Re Blend Complete', value: 'Re_Blend_Complete'},
          {key: 'Part Returned', value: 'Part Returned'},
          {key: 'Returned', value: 'Returned'},
          {key: 'Customer Received', value: 'Customer-Received'},
          {key: 'Dispatch Booked', value: 'Dispatch Booked'},
          {key: 'Expired', value: 'Expired'},
          {key: 'In QC', value: 'In-QC'},
          {key: 'Out of Stock', value: 'Out_of_Stock'},
        ]
      }
    },
    components: {
      'v-select': vSelect,
      AssignFormulationStockPopUp,
      AdjustProductStockPopUp,
      ProductStockLabelPopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted() {
      // this.$refs.filterCard.isContentCollapsed = true
      // this.$refs.filterCard.maxHeight = '1.5rem'
      //
      if (this.$route.query.code ) {
        this.formulation_code = this.$route.query.code
      }
    },
    methods: {
      async refreshData () {
        this.fetchFormulationStockInventory()
      },
      async fetchFormulationStockInventory() {
        await this.$vs.loading({
          container: '#sundry-item-list-table',
          scale: 0.45
        })
        try {
          const {data} = await ManufacturingRepository.getFormulationStock(this.page, `filter[formulation-code]=${this.formulation_code}&${this.filterQuery}`, this.perPage)
          this.items =  data.data
            // .filter((m) => m.status === 'In_Stock')
          this.meta = data.meta
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#sundry-item-list-table > .con-vs-loading')
      },

      filterQueryUpdate (){
        this.fetchFormulationStockInventory()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchFormulationStockInventory()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchFormulationStockInventory()
        }

      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      close(){
        this.activePrompt = false
      },
      onClickAssignFormulation(formulation_id, inventory_id, status, completed_quantity) {
        if(status === 'In_Stock') {
          this.$refs.assignFormulationStockPopUp.openPopup(formulation_id, inventory_id, completed_quantity)
        }
      },
      onClickStockAdjust(data) {
        if(['In_Stock', 'Expired', 'In-Dispatch'].includes(data.status)) {
          this.$refs.adjustProductStockPopUp.openPopup(data)
        }
      },
      async onClickUnAllocateStock(data) {
        try {
          await ManufacturingRepository.unAllocateFormulationStockInventory(data.id)
          await this.refreshData()
          this.showSuccessMessage('Unallocated Successfully')
        } catch (error) {
          this.convertAndNotifyError(e)
        }
      },
      toFixed(number) {
        return Number(number).toFixed(4)
      },
      onClickLabelPrint(data) {
        this.$refs.productStockLabelPopUp.openPopup(data.id, data.work_order, data.formulation_code)
      },
      onClickOpenWo(id) {
        const route = this.$router.resolve({ path: `/pages/manufacturing/work-orders/${id}/details` });
        window.open(route.href, '_blank');
      }
    },
    watch : {
      page(){
        this.fetchFormulationStockInventory()
      },
      perPage() {
        this.fetchFormulationStockInventory()
      },
      formulation_code() {
        this.fetchFormulationStockInventory()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
